var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: "Visualizar dados do usuário",
        width: 1000,
        hasFooter: false
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("app-divider", {
            attrs: {
              label: _vm.isPessoaJuridica ? "Pessoa Jurídica" : "Pessoa Física"
            }
          }),
          _c("app-display", {
            staticClass: "margin-top",
            attrs: {
              label: _vm.isPessoaJuridica ? "Razão Social:" : "Nome:",
              content: _vm.usuario.pessoa.nomeRazaoSocial
            }
          }),
          _c("app-display", {
            attrs: {
              label: _vm.isPessoaJuridica ? "CNPJ:" : "CPF:",
              content: _vm.isPessoaJuridica
                ? _vm.usuario.pessoa.pessoaJuridica.cnpj
                : _vm.usuario.pessoa.pessoaFisica.cpf
            }
          }),
          _c("app-display", {
            staticClass: "extra-margin-bottom",
            attrs: { label: "E-mail:", content: _vm.usuario.pessoa.email }
          }),
          _c("app-display-multiple", {
            attrs: {
              label: "Telefones:",
              content: _vm.usuario.pessoa.telefones.map(function(telefone) {
                return telefone.numero
              })
            }
          }),
          _c("app-divider", {
            staticClass: "margin-top",
            attrs: { label: "Endereço" }
          }),
          _c(
            "div",
            { staticClass: "margin-top" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "CEP:", content: _vm.endereco.cep }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Bairro:",
                          content: _vm.endereco.bairro
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Logradouro:",
                          content: _vm.endereco.logradouro
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Número:",
                          content: _vm.endereco.semNumero
                            ? "S/N"
                            : _vm.endereco.numero
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { class: { "extra-margin-bottom": !_vm.endereco.complemento } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Município:",
                          content: _vm.endereco.municipio.nome
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "UF:",
                          content: _vm.endereco.municipio.codigoEstado
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.endereco.complemento
            ? _c("app-display", {
                staticClass: "extra-margin-bottom",
                attrs: {
                  label: "Complemento:",
                  content: _vm.endereco.complemento
                }
              })
            : _vm._e(),
          _c("app-divider", { attrs: { label: "Dados do usuário" } }),
          _c(
            "div",
            { staticClass: "margin-top margin-bottom" },
            [
              _c("app-display", {
                attrs: { label: "Situação:", content: _vm.situacao }
              }),
              _c("app-display", {
                attrs: {
                  label: _vm.usuario.perfis.length > 1 ? "Perfis:" : "Perfil:",
                  content: _vm.perfis
                }
              }),
              _vm.usuario.municipioPrefeitura
                ? _c("app-display", {
                    attrs: {
                      label: "Prefeitura:",
                      content: _vm.usuario.municipioPrefeitura.nome
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-255dd22b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-255dd22b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalVisualizarUsuario.vue
// module id = null
// module chunks = 